import { render, staticRenderFns } from "./RouteQcItem.vue?vue&type=template&id=70da1232&scoped=true"
import script from "./RouteQcItem.vue?vue&type=script&lang=js"
export * from "./RouteQcItem.vue?vue&type=script&lang=js"
import style0 from "./RouteQcItem.vue?vue&type=style&index=0&id=70da1232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da1232",
  null
  
)

export default component.exports